// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".upload-photo .upload{display:inline-block;width:auto;margin:5px}.upload-photo .upload .upload-image-item{width:120px;height:80px;display:flex;align-items:center;justify-content:center}.upload-photo .upload .upload-image-item img{max-width:100%;max-height:100%}", ""]);
// Exports
module.exports = exports;
